import { types, Instance } from 'mobx-state-tree';
const { model, string, array, boolean, maybe, maybeNull, identifier, number } = types;

export const AdminModel = model('AdminModel', {
  dn: identifier,
  uid: maybe(string), //login
  cn: string,
  base: maybe(string),
  sn: string, //last name
  givenname: maybe(string), //first name
  description: maybe(string),
  mail: maybe(string),
  l: maybe(string),
  st: maybe(string),
  postaladdress: maybe(string),
  roomnumber: maybe(string),
  telephonenumber: maybe(string),
  mobile: maybe(string),
  pager: maybe(string),
  facsimiletelephonenumber: maybe(string),
  labeleduri: maybe(string),
  preferredlanguage: maybe(string),
  userpassword: maybe(string), //password
  passwordMethod: maybe(string),
  homepostaladdress: maybe(string),
  homephone: maybe(string),
  o: maybe(string),
  ou: maybe(string),
  departmentnumber: maybe(string),
  employeenumber: maybe(string),
  employeetype: maybe(string),
  objectclass: array(string),
  manager: maybe(string),
  locked: maybe(boolean),
  notify: maybe(boolean),
  createtimestamp: maybeNull(string),
  modifytimestamp: maybeNull(string),
  carlicense: string,
  displayname: maybe(string),
  googleId: maybeNull(string),
  zoomId: maybeNull(string),
  microsoftId: maybeNull(string),
  reSyncProvider: array(string),
  user_id: number,
});

export type IAdminModel = Instance<typeof AdminModel>;
